<template>
	<div class="detail-wrap">
		<el-form ref="editForm" :model="system_notice">
			<div class="d-header clearfix">
				<div class="fl">
					<i class="el-icon-info" />
					{{ dataId ? '查看' : '新增' }}公告
				</div>
				<div class="fr">
					<el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
					<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
				</div>
			</div>
			<div class="d-cont">
				<div class="d-item">
					<div class="title first"><b>基本信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<th>
									<em class="f-red">*</em>
									标题
								</th>
								<td>
									<el-form-item prop="title" :rules="[{ required: true, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="system_notice.title" clearable />
									</el-form-item>
								</td>
								<th>副标题</th>
								<td>
									<el-form-item prop="secondTitle" :rules="[{ required: false, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="system_notice.secondTitle" clearable />
									</el-form-item>
								</td>
								<th>设置</th>
								<td>
									<el-checkbox label="是否发布" v-model="system_notice.publish"></el-checkbox>
									<el-checkbox label="是否置顶" v-model="system_notice.top"></el-checkbox>
								</td>
								<th>
									<em class="f-red">*</em>
									语言
								</th>
								<td>
									<el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
										<el-select v-model="system_notice.languageId" @change="changeLanguage">
											<el-option
												v-for="languageDTO in languageDTOs"
												:key="'languageDTO' + languageDTO.id"
												:value="languageDTO.id"
												:label="languageDTO.language"
											></el-option>
										</el-select>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<th>附件</th>
								<td colspan="7"><baseUpload accept="file" multi="true" :file.sync="sysNoticeAttachmentDTOs"></baseUpload></td>
							</tr>
							<tr>
								<th>创建人</th>
								<td>{{ system_notice.createBy }}</td>
								<th>创建时间</th>
								<td>{{ system_notice.createDate }}</td>
								<th>更新人</th>
								<td>{{ system_notice.modifyBy }}</td>
								<th>更新时间</th>
								<td>{{ system_notice.modifyDate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="d-item">
					<div class="title"><b>内容</b></div>
					<table class="table-detail" style="width: 100%;">
						<tbody>
							<tr>
								<td colspan="=6"><tinymce v-model="system_notice.content" :language="lan" :height="300" /></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
export default {
	name: 'system_noticeEdit',
	props: ['_dataId'],
	components: {
		Tinymce
	},
	data() {
		return {
			lan: 'zh_CN',
			tabIndex: 0,
			isEdit: false,
			dataId: '',
			system_notice: {},
			sysNoticeAttachmentDTOs: [],
			languageDTOs: []
		};
	},
	created() {
		if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
	},
	mounted() {
		this.initLauguage();
		this.initAttachfo();
		this.getData();
	},
	methods: {
		getData() {
			if (this.dataId && !isNaN(this.dataId)) {
				this.isEdit = true;
				this.$http({
					url: USER_PREFIX + `/system_notice/get`,
					method: `post`,
					data: {
						id: this.dataId
					},
					isLoading: true,
					modalStrictly: true,
					success: res => {
						this.system_notice = res.objx || {};
					}
				});
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = USER_PREFIX + (this.isEdit ? `/system_notice/update` : `/system_notice/save`);
						let formData = this.system_notice;
						formData.sysNoticeAttachmentDTOs = this.sysNoticeAttachmentDTOs || [];

						this.$http({
							url: url,
							method: `post`,
							data: formData,
							isLoading: true,
							success: res => {
								this.$message({
									message: res.content,
									type: 'success',
									duration: 500,
									onClose: t => {
										if (this.isEdit) {
											this.$baseReload();
										} else {
											this.$baseReload({
												updateParam: {
													_dataId: res.objx
												}
											});
										}
									}
								});
							}
						});
					});
				}
			});
		},
		initAttachfo() {
			//初始化附件信息
			if (this.dataId) {
				this.$http({
					url: USER_PREFIX + '/system_notice/getAttachments',
					method: `post`,
					data: { id: this.dataId },
					isLoading: true,
					modalStrictly: true,
					success: res => {
						this.sysNoticeAttachmentDTOs = res.objx || [];
					}
				});
			}
		},
		initLauguage() {
			this.$http({
				url: HXFW_PREFIX + `/lauguage/lists`,
				method: `post`,
				data: {},
				isLoading: true,
				modalStrictly: true,
				success: res => {
					this.languageDTOs = res.objx || [];
					if (!this.dataId) {
						this.languageDTOs.some(row => {
							let flag = row.language == '中文';
							if (flag) {
								this.system_notice.languageId = row.id;
								this.system_notice.languageName = row.language;
								this.system_notice.languageCode = row.languageCode;
							}
							return false;
						});
					}
				}
			});
		},
		changeLanguage(value) {
			if (value) {
				let rows = this.languageDTOs.filter(row => row.id == value);
				if (rows.length) {
					let row = rows[0];
					this.system_notice.languageName = row.language;
					this.system_notice.languageCode = row.languageCode;
				}
			} else {
				this.system_notice.languageName = null;
				this.system_notice.languageCode = null;
			}
		},
	}
};
</script>

<style></style>
